import { fn } from '@storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { CheckboxButtonBarProps } from './CheckboxButtonBar';

import { CheckboxButtonBar } from './CheckboxButtonBar';

const codeString =
  '<CheckboxButtonBar checkboxes={} defaultValues={} label={} labelPosition={} required={} notValidatedText={} disableGroup={} onSetValues={} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Molecules/CheckboxButtonBar',
  component: CheckboxButtonBar,
  argTypes: {
    checkboxes: {
      table: {
        disable: true,
      },
    },
    defaultValues: {
      table: {
        disable: true,
      },
    },
    label: {
      control: 'text',
    },
    labelPosition: {
      control: 'radio',
      options: ['top', 'left'],
    },
    required: {
      control: 'boolean',
    },
    notValidatedText: {
      control: 'text',
    },
    disableGroup: {
      control: 'boolean',
    },
    onSetValues: {
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: CheckboxButtonBar,
    codeString: codeString,
  },
} as Meta<CheckboxButtonBarProps>;

const Template: StoryFn<CheckboxButtonBarProps> = (args) => <CheckboxButtonBar {...args} />;

export const CheckboxButtonBarExample = Template.bind({});
CheckboxButtonBarExample.args = {
  label: 'Periode',
  required: true,
  checkboxes: [
    {
      label: '1.1',
      value: '1',
    },
    {
      label: '1.2',
      value: '2',
    },
    {
      label: '1.3',
      value: '3',
    },
  ],
  defaultValues: ['1', '2'],
  labelPosition: 'top',
  onSetValues: fn(),
};
